module.exports = __webpack_public_path__ + "static/img/91BM-073-GuanGuan.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stars/91BM-073-GuanGuan.jpg
// module id = uTRx
// module chunks = 0